import { IRequest } from "../../utilities/HttpRequest";

export const Requests = {
  authorize: (applicationId: string): IRequest => {
    return {
      relativeUrl: "/authorize",
      endPoint: process.env.APP_COHORT_BUILDER,
      header: { "application-guid": applicationId, "Content-Type": "application/vnd.api+json" }
    };
  },
};
